import { userManager } from "@ssf/auth-components";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import { getStoredGuestId } from "./guestIdentity.js";
const PLAY_WORKER_URL = process.env.PLAY_WORKER_URL;
if (!PLAY_WORKER_URL) {
    throw new Error("Missing `PLAY_WORKER_URL`");
}
const links = [
    httpBatchLink({
        url: PLAY_WORKER_URL,
        async headers() {
            const { access_token } = (await userManager.getUser()) ?? {};
            if (access_token) {
                return { Authorization: `Bearer ${access_token}` };
            }
            const guestId = getStoredGuestId();
            return guestId ? { "Guest-ID": guestId } : {};
        },
    }),
];
export const trpcClient = createTRPCClient({ links });
export const trpcContext = createTRPCContext();
//# sourceMappingURL=trpcClient.js.map